/* global axios */
import ApiClient from '../ApiClient';

class ChatlottaReplySuggestionsAPI extends ApiClient {
  constructor() {
    super('chatlotta/reply_suggestions', { accountScoped: true });
  }

  createSuggestion(message) {
    return axios.post(this.url, { message });
  }
}

export default new ChatlottaReplySuggestionsAPI();
